import { render } from "./CardTransactionDesktop.vue?vue&type=template&id=58046340&scoped=true"
import script from "./CardTransactionDesktop.vue?vue&type=script&lang=js"
export * from "./CardTransactionDesktop.vue?vue&type=script&lang=js"

import "./CardTransactionDesktop.vue?vue&type=style&index=0&id=58046340&scoped=true&lang=css"

import exportComponent from "/Users/derem1991/workspace/newear/frontend/kajot/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58046340"]])

export default __exports__